import React, { useContext, useRef, useState, useEffect } from "react";
import { GlobalContext } from "../Context/GlobalState";
import swal from "sweetalert";
import { FaQuoteRight, FaTable } from "react-icons/fa";

import {
  FaBold,
  FaImage,
  FaItalic,
  FaLink,
  FaParagraph,
  FaUnderline,
  FaVideo,
} from "react-icons/fa";
import { RiListUnordered } from "react-icons/ri";
import { GoListOrdered } from "react-icons/go";
const Addblogeditor = ({ editorRef }) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const savedSelection = useRef(null);
  const { siteid, setsiteid, siteurl, setURL, siteObj, Productname } =
    useContext(GlobalContext);

  const formatText = (command, value = null) => {
    document.execCommand(command, false, value);
  };

  const insertLink = () => {
    const url = prompt("Enter the URL");
    if (url) formatText("createLink", url);
  };

  const insertVideo = () => {
    const url = prompt("Enter YouTube Embed URL (iframe)");
    if (url) {
      const iframe = `<iframe width="560" height="315" src="${url}" frameborder="0" allowfullscreen></iframe>`;
      document.execCommand("insertHTML", false, iframe);
    }
  };

  const insertImage = () => {
    saveCursor();
    fileInputRef.current.click();
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    const reader = new FileReader();
    reader.onloadend = async () => {
      const binaryData = reader.result;
      const filename1 = file.name;

      try {
        const response = await fetch(
          `${siteurl}/api/upload.php?filename=${encodeURIComponent(filename1)}`,
          {
            method: "POST",
            body: binaryData,
            headers: {
              "Content-Type": "application/octet-stream",
            },
          }
        );

        const result = await response.json();

        if (result.status === "success") {
          const imageUrl = result.file_url;

          restoreCursor();
          document.execCommand("insertImage", false, imageUrl);

          const insertedImage = document.querySelector(
            'img[src="' + imageUrl + '"]'
          );
          if (insertedImage) {
            insertedImage.style.width = "200px";
            insertedImage.style.height = "200px";
            insertedImage.style.objectFit = "cover";
          }

          swal({
            title: "Success!",
            text: `File uploaded successfully. URL: ${imageUrl}`,
            icon: "success",
            button: "OK",
          });
          setLoading(false);
        } else {
          swal({
            title: "Error!",
            text: result.message,
            icon: "error",
            button: "OK",
          });
        }
      } catch (error) {
        setLoading(false);
        swal({
          title: "Upload Failed!",
          text: "Something went wrong while uploading the image.",
          icon: "error",
          button: "OK",
        });
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const saveCursor = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      savedSelection.current = selection.getRangeAt(0);
    }
  };

  const restoreCursor = () => {
    const selection = window.getSelection();
    if (savedSelection.current && selection) {
      selection.removeAllRanges();
      selection.addRange(savedSelection.current);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    const html =
      clipboardData.getData("text/html") || clipboardData.getData("text/plain");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const allElements = tempDiv.querySelectorAll("*");
    allElements.forEach((el) => {
      el.removeAttribute("style");
      el.removeAttribute("class");
    });
    const cleanedHtml = tempDiv.innerHTML;
    document.execCommand("insertHTML", false, cleanedHtml);
  };
  const insertTable = () => {
    saveCursor(); 
  
    const rows = parseInt(prompt("Enter number of rows:"));
    const cols = parseInt(prompt("Enter number of columns:"));
    const headerOption = prompt("Do you want a header row? (yes/no)")?.toLowerCase();
  
    if (!rows || !cols) return;
  
    let table = `<table style="border-collapse: collapse; width: 100%;" border="1">`;
  
    if (headerOption === "yes") {
      table += "<thead><tr>";
      for (let c = 0; c < cols; c++) {
        table += `<th style="padding: 6px; background:#f2f2f2;">Header ${c + 1}</th>`;
      }
      table += "</tr></thead>";
    }
  
    table += "<tbody>";
    const startRow = headerOption === "yes" ? 1 : 0;
  
    for (let r = startRow; r < rows; r++) {
      table += "<tr>";
      for (let c = 0; c < cols; c++) {
        table += `<td style="padding: 6px;">Cell</td>`;
      }
      table += "</tr>";
    }
  
    table += "</tbody></table><br/>";
  
    restoreCursor(); // ✅ restore position before inserting
    document.execCommand("insertHTML", false, table);
  };
  return (
    <div className=" ">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={require("../../assets/images/seoimages/aiload.gif")}
            alt="Loading..."
            style={{ width: "80px", height: "80px" }}
          />
        </div>
      )}
      <div className="toolbar">
        {[1, 2, 3, 4, 5, 6].map((h) => (
          <button key={h} onClick={() => formatText("formatBlock", `<h${h}>`)}>
            H{h}
          </button>
        ))}
        <button onClick={() => formatText("formatBlock", "<blockquote>")}>
          <FaQuoteRight />
        </button>
        <button onClick={() => formatText("formatBlock", "<p>")}>
          <FaParagraph />
        </button>
        <button onClick={() => formatText("insertUnorderedList")}>
          <RiListUnordered style={{ fontSize: "1.2rem" }} />
        </button>
        <button onClick={() => formatText("insertOrderedList")}>
          <GoListOrdered style={{ fontSize: "1.2rem" }} />
        </button>
        <button onClick={() => formatText("bold")}>
          <FaBold />
        </button>
        <button onClick={() => formatText("italic")}>
          <FaItalic />
        </button>
        <button onClick={() => formatText("underline")}>
          <FaUnderline />
        </button>
        <button onClick={insertTable}><FaTable />
        </button>
        <input
          type="color"
          onChange={(e) => formatText("foreColor", e.target.value)}
          title="Text Color"
        />
        <button onClick={insertLink}>
          <FaLink />
        </button>
        <button onClick={insertImage}>
          <FaImage />
        </button>
        <button onClick={insertVideo}>
          <FaVideo />
        </button>
      </div>
      <div
        ref={editorRef}
        contentEditable
        onPaste={handlePaste}
        onMouseUp={saveCursor}
        onKeyUp={saveCursor}
        style={{
          border: "1px solid #ccc",
          height: "70vh",
          padding: "10px",
          marginTop: "10px",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      ></div>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleImageUpload}
      />

<style>
  {`
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .toolbar {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      margin-bottom: 10px;
    }
    .toolbar button {
      padding: 5px 10px;
      border: none;
      background: #eee;
      cursor: pointer;
      border-radius: 4px;
    }
    .toolbar button:hover {
      background: #ddd;
    }

    blockquote {
      border-left: 4px solid #ccc;
      margin: 1em 0;
      padding: 0.5em 1em;
      color: #555;
      font-style: italic;
      background: #f9f9f9;
    }
  `}
</style>

    </div>
  );
};

export default Addblogeditor;
